import React from 'react';

function OgField({ label, value, req = false, num = false, muted = false, small = false, span = false }) {
  const hasValue = value !== null && value !== undefined && value !== '';
  const valClass = 'val' + (num ? ' num' : '') + (muted || !hasValue ? ' muted' : '') + (small ? ' small' : '');
  return (
    <div className={'og-field' + (span ? ' span-2' : '')}>
      <div className="lbl">
        {label}
        {req ? <span className="req">*</span> : null}
      </div>
      <div className={valClass}>{hasValue ? value : '—'}</div>
    </div>
  );
}

export default OgField;
